


















import { Vue, Component, Watch, Prop } from "vue-property-decorator";
import { MapMarker } from "@/models/GeoLocation.ts";
import { marker } from "leaflet";

@Component({})
export default class Map extends Vue {
  @Prop({ type: Array, default: () => [] }) markers!: MapMarker[];

  private center = { lat: 0, lng: 0 };
  private zoom = 0;
  private mapOptions = {};
  private currentmarker = null;

  @Watch("markers", { immediate: true, deep: true })
  onMarkersChanged() {
    this.center = this.calculateCenter();
    this.zoom = this.calculateZoom();
  }

  get computedMarkers() {
    return this.markers || [];
  }

  get computedCenter() {
    return this.calculateCenter();
  }

  calculateCenter() {
    let center = { lat: 0, lng: 0 };
    const markers = this.markers || [];
    const total = markers.length;
    if (total > 0) {
      for (const _marker of markers) {
        const { lat, lng } = _marker.position;
        center.lat += lat;
        center.lng += lng;
      }
      center.lat /= total;
      center.lng /= total;
    }
    return center;
  }

  calculateZoom() {
    const markers = this.markers || [];
    const lats = markers.map(_marker => _marker.position.lat);
    const lngs = markers.map(_marker => _marker.position.lng);
    const topLeft = {
      lat: Math.max(...lats),
      lng: Math.min(...lats),
    };
    const bottomRight = {
      lat: Math.min(...lats),
      lng: Math.max(...lats),
    };
    const latlen = Math.abs(topLeft.lat - bottomRight.lat);
    const lnglen = Math.abs(topLeft.lng - bottomRight.lng);
    const dst = Math.max(latlen, lnglen);
    let zoom = Math.round(Math.log((960 * 360) / dst / 256) / Math.LN2) - 2; // just some magic
    if (zoom > 20) {
      zoom = 10;
    }
    return zoom;
  }
}
